import React, { useState, useRef } from "react";
import { Menu, X, ChevronDown } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hoveredDropdown, setHoveredDropdown] = useState("");
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState("");
  const timeoutRef = useRef(null);
  const location = useLocation();

  const navItems = [
    {
      name: "AboutUs",
      dropdown: [
        { label: "Why Choose Us", path: "/aboutus/whyus" },
        { label: "Our Clients", path: "/aboutus/clients" },
        { label: "Strategic Partners", path: "/aboutus/strategicpartners" },
        
      ]
    },
    {
      name: "Services",
      dropdown: [
        { label: "Infrastructure Management", path: "/services/Infra-management" },
        { label: "IT Hardware Deployment Services", path: "/services/ITHardwareDeploymentServices" },
        { label: "Network Security", path: "/services/network-security" },
        { label: "Rental Services", path: "/services/device-rental" },
        { label: "Facility Management Services", path: "/services/FMSServices" },
        { label: "Cloud Solutions", path: "/services/cloud-solutions" }
      ]
    },
    { name: "ContactUs", path: "/contact" }
  ];

  const isActive = (item) => {
    if (item.path && !item.dropdown) {
      return location.pathname === item.path;
    }
    if (item.dropdown) {
      return item.dropdown.some((sub) => location.pathname === sub.path);
    }
    return false;
  };

  const linkClass = (active = false) =>
    `relative text-lg font-semibold px-3 py-2 
     ${active ? "text-blue-950 border-b-2 border-blue-950" : "text-black"} 
     hover:text-blue-950 transition duration-150 ease-in-out`;

  const handleMouseEnter = (name) => {
    clearTimeout(timeoutRef.current);
    setHoveredDropdown(name);
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setHoveredDropdown("");
    }, 500);
  };

  return (
    <nav className="bg-white sticky top-0 z-50 shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex justify-between items-center">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2">
          <img
            src="/sairaj-logo.png"
            alt="Sairaj Infotech Logo"
            className="h-20 w-auto object-contain"
          />
          <h2>
            <span className="text-2xl font-bold text-blue-950">SAIRAJ INFOTECH</span>
            <div className="font-cursive text-black">Empowering IT infrastructure</div>
          </h2>
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center justify-center flex-1 space-x-10">
          {navItems.map((item) =>
            item.dropdown ? (
              <div
                key={item.name}
                className="relative"
                onMouseEnter={() => handleMouseEnter(item.name)}
                onMouseLeave={handleMouseLeave}
              >
                <button className={`${linkClass(isActive(item))} flex items-center gap-1`}>
                  {item.name}
                  <ChevronDown
                    size={16}
                    className={`transition-transform duration-300 ${
                      hoveredDropdown === item.name ? "rotate-180" : ""
                    }`}
                  />
                </button>
                <div
                  className={`absolute top-full left-0 mt-2 bg-white rounded shadow-lg w-64 z-50 transition-opacity duration-200 ${
                    hoveredDropdown === item.name ? "opacity-100 visible" : "opacity-0 invisible"
                  }`}
                >
                  {item.dropdown.map((sub) => (
                    <Link
                      key={sub.label}
                      to={sub.path}
                      className={`block px-4 py-2 text-gray-800 hover:bg-gray-100 ${
                        location.pathname === sub.path ? "bg-gray-100 font-medium" : ""
                      }`}
                    >
                      {sub.label}
                    </Link>
                  ))}
                </div>
              </div>
            ) : (
              <Link
                key={item.name}
                to={item.path}
                className={linkClass(isActive(item))}
              >
                {item.name}
              </Link>
            )
          )}
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X size={24} color="black" /> : <Menu size={24} color="black" />}
          </button>
        </div>
      </div>

      {/* Mobile Dropdown */}
      {isOpen && (
        <div className="md:hidden bg-white px-4 pb-4 space-y-2">
          {navItems.map((item) =>
            item.dropdown ? (
              <div key={item.name} className="space-y-1">
                <button
                  onClick={() =>
                    setMobileDropdownOpen(
                      mobileDropdownOpen === item.name ? "" : item.name
                    )
                  }
                  className="flex justify-between items-center w-full font-semibold text-gray-800"
                >
                  {item.name}
                  <ChevronDown
                    size={16}
                    className={`transition-transform ${
                      mobileDropdownOpen === item.name ? "rotate-180" : ""
                    }`}
                  />
                </button>
                {mobileDropdownOpen === item.name && (
                  <div className="ml-4 space-y-1">
                    {item.dropdown.map((sub) => (
                      <Link
                        key={sub.label}
                        to={sub.path}
                        className={`block text-gray-700 hover:text-blue-950 transition ${
                          location.pathname === sub.path ? "text-blue-950 font-medium" : ""
                        }`}
                        onClick={() => {
                          setIsOpen(false);
                          setMobileDropdownOpen("");
                        }}
                      >
                        {sub.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ) : (
              <Link
                key={item.name}
                to={item.path}
                className={`block text-gray-800 font-semibold hover:text-blue-950 transition ${
                  location.pathname === item.path ? "text-blue-950" : ""
                }`}
                onClick={() => setIsOpen(false)}
              >
                {item.name}
              </Link>
            )
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
